import { defineMessages, IntlShape } from 'react-intl'
import * as yup from 'yup'

import { ICoordinatesFormValues } from 'features/RoutingProjects/components/LocationDetails/CoordinatesForm/types'
import { isValidLatAndLong } from 'utils/map'

const coordinateMessages = defineMessages({
  required: {
    id: 'routingProject.locationDetails.coordinatesForm.required',
    defaultMessage: 'Can not be empty'
  },
  invalidFormat: {
    id: 'routingProject.locationDetails.coordinatesForm.invalidFormat',
    defaultMessage: 'Invalid format, please use the following format: 52.5200, 13.4050'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<ICoordinatesFormValues> => {
  return yup.object().shape({
    coordinates: yup
      .string()
      .test('is-valid-format', intl.formatMessage(coordinateMessages.invalidFormat), (value) => {
        if (!value) return true
        const [lat, lon] = value.split(',').map((v) => parseFloat(v))
        return isValidLatAndLong(lat, lon)
      })
      .required(intl.formatMessage(coordinateMessages.required))
  })
}
